import React from 'react';

import * as CatalogueSearch from '@/core/components/CatalogueSearch';
import Icons from '@/core/components/Icons';
import SchemaOrg from '@/core/components/SchemaOrg';
import { useComponentsContext } from '@/core/lib/components/components.context';
import { useNativeContext } from '@/core/lib/native/native.context';
import Store from '@/core/lib/new-architecture/store';
import { useRouterContext } from '@/core/lib/router/router.context';
import { useTranslationContext } from '@/core/lib/translation/translation.context';
import ItemList from '@/core/pages/Catalogue/ItemList';
import type { PageWithLayoutsAndProviders } from '@/core/pages/page.types';

const Catalogue: PageWithLayoutsAndProviders = () => {
  const { t } = useTranslationContext(['common', 'catalogue']);
  const { isNative } = useNativeContext();
  const { Page, Content, MetaTitle } = useComponentsContext();

  const { data: catalogue, next, isLoading, isFetchingNextPage, hasNext, total, notFound } = Store.catalogue.useCatalogue();

  const { currentPathname } = useRouterContext();

  if (notFound && !isLoading) {
    return <div className="flex h-screen items-center justify-center">{t('errors.not-found', { ns: 'common' })}</div>;
  }

  return (
    <>
      {catalogue && (
        <>
          <MetaTitle meta={catalogue.seo} />
          <SchemaOrg schema={catalogue.getBreadcrumbListSchema(t)} />
        </>
      )}

      <Page>
        <Content scroll={currentPathname}>
          {isNative && (
            <div className="sticky top-0 z-50 flex w-full bg-bg-primary pt-safe-top">
              <div className="flex w-full py-4">
                <CatalogueSearch.CatalogueSearchButton />
              </div>
            </div>
          )}
          <CatalogueSearch.CatalogueSearchRecapSeo />

          <CatalogueSearch.CatalogueSearchCircularModal />

          {isLoading && (
            <div aria-label={t('spinner.aria-valuetext', { ns: 'catalogue' })} className="flex h-screen items-center justify-center">
              <Icons icon="spinner" size="40" color="button-default" />
            </div>
          )}

          {!isLoading && catalogue?.donations && (
            <ItemList donations={catalogue.donations} search={catalogue.search} hasNext={hasNext} shouldFetchNext={hasNext && !isFetchingNextPage} total={total} next={next} />
          )}

          {!isNative && (
            <div className="mb-20 mt-5 pb-safe-bottom">
              <CatalogueSearch.CataloguePagination total={total} />
            </div>
          )}
        </Content>
      </Page>

      {isNative && <CatalogueSearch.CatalogueSearchDialog />}
    </>
  );
};

export default Catalogue;
